import React from 'react';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useLanguage } from '../../../../contexts/LanguageContext';
import { useGetInternalRetailPartsDetailQuery } from '../../../../api/endpoints/parts';

const InternalRetailPartsDetailDialog = ({ visible, onHide, transfer }) => {
    const { th } = useLanguage();

    // Fetch detail data
    const { data: detailParts = [], isLoading } = useGetInternalRetailPartsDetailQuery(
        transfer?.id,
        { skip: !visible || !transfer?.id }
    );

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return date.toLocaleDateString('tr-TR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const formatCurrency = (value) => {
        if (value == null) return '-';
        return value.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    return (
        <Dialog
            header={th('internalRetailParts.detailTitle') || 'Transfer Detayı'}
            visible={visible}
            style={{ width: '90vw', maxWidth: '900px' }}
            modal
            onHide={onHide}
        >
            {/* Header Info - 2x2 Grid */}
            {transfer && (
                <div className="grid mb-4">
                    <div className="col-12 md:col-6">
                        <div className="surface-100 p-3 border-round">
                            <label className="block text-500 text-sm mb-1">
                                {th('internalRetailParts.transferId') || 'Transfer ID'}
                            </label>
                            <span className="font-semibold text-lg">{transfer.id}</span>
                        </div>
                    </div>
                    <div className="col-12 md:col-6">
                        <div className="surface-100 p-3 border-round">
                            <label className="block text-500 text-sm mb-1">
                                {th('internalRetailParts.senderDealer') || 'Gönderen Bayi'}
                            </label>
                            <span className="font-semibold text-lg">{transfer.senderDealer || '-'}</span>
                        </div>
                    </div>
                    <div className="col-12 md:col-6">
                        <div className="surface-100 p-3 border-round">
                            <label className="block text-500 text-sm mb-1">
                                {th('internalRetailParts.receiverDealer') || 'Alıcı Bayi'}
                            </label>
                            <span className="font-semibold text-lg">{transfer.receiverDealer || '-'}</span>
                        </div>
                    </div>
                    <div className="col-12 md:col-6">
                        <div className="surface-100 p-3 border-round">
                            <label className="block text-500 text-sm mb-1">
                                {th('internalRetailParts.totalAmount') || 'Toplam Tutar'}
                            </label>
                            <span className="font-semibold text-lg text-primary">
                                {formatCurrency(transfer.totalAmount)}
                            </span>
                        </div>
                    </div>
                    <div className="col-12 md:col-6">
                        <div className="surface-100 p-3 border-round">
                            <label className="block text-500 text-sm mb-1">
                                {th('internalRetailParts.createdDate') || 'Oluşturma Tarihi'}
                            </label>
                            <span className="font-semibold text-lg">{formatDate(transfer.createdDate)}</span>
                        </div>
                    </div>
                </div>
            )}

            {/* Parts Table */}
            <div className="mt-3">
                <h3 className="mb-3">{th('internalRetailParts.partsTitle') || 'Parça Listesi'}</h3>
                <DataTable
                    value={detailParts}
                    loading={isLoading}
                    emptyMessage={th('common.noRecords') || 'Kayıt bulunamadı'}
                    stripedRows
                    showGridlines
                    size="small"
                    dataKey="partCode"
                >
                    <Column
                        header="#"
                        body={(row, opts) => opts.rowIndex + 1}
                        style={{ width: '50px', textAlign: 'center' }}
                    />
                    <Column
                        field="partCode"
                        header={th('product.code') || 'Parça Kodu'}
                        style={{ width: '140px' }}
                    />
                    <Column
                        field="partDesc"
                        header={th('product.name') || 'Parça Adı'}
                    />
                    <Column
                        field="quantity"
                        header={th('product.quantity') || 'Miktar'}
                        style={{ width: '100px', textAlign: 'right' }}
                        body={(row) => formatCurrency(row.quantity)}
                    />
                    <Column
                        field="sellingPrice"
                        header={th('basket.price') || 'Birim Fiyat'}
                        style={{ width: '130px', textAlign: 'right' }}
                        body={(row) => `${formatCurrency(row.sellingPrice)} ${row.currency || ''}`}
                    />
                    <Column
                        header={th('internalRetailParts.lineTotal') || 'Satır Toplamı'}
                        style={{ width: '150px', textAlign: 'right' }}
                        body={(row) => `${formatCurrency(row.sellingPrice * (row.quantity || 0))} ${row.currency || ''}`}
                    />
                </DataTable>
            </div>
        </Dialog>
    );
};

export default InternalRetailPartsDetailDialog;

